import { render, staticRenderFns } from "./DetalhesAcordo.vue?vue&type=template&id=0db43fca&"
import script from "./DetalhesAcordo.vue?vue&type=script&lang=js&"
export * from "./DetalhesAcordo.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesAcordo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports